import { ComponentNames } from 'src/app/helper/componentNames';
import { BaseComponent } from '../BaseComponent';

export class PersonsPerSquareMeterComponent extends BaseComponent{
    constructor() {
        super();
        this.componentType = ComponentNames.personsPerSquareMeterComponent;
    }
    overrideDefaultValue:boolean;
    amountOfPeople:number;
}